import React from "react";
import styles from "../BrickContainer/styles.module.css";

type CrackedBrickProps = {
	isSmall: boolean;
};

export const DarkCrack: React.FC<CrackedBrickProps> = ({ isSmall }) =>
	isSmall ? (
		<svg
			width="66"
			height="51"
			viewBox="0 0 66 51"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="0.624878"
				y="0.25"
				width="65"
				height="50"
				rx="3"
				fill="url(#paint0_linear)"
			/>
			<mask
				id="mask0"
				mask-type="alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="66"
				height="51"
			>
				<rect
					x="0.624878"
					y="0.25"
					width="65"
					height="50"
					rx="3"
					fill="#C4C4C4"
				/>
			</mask>
			<g mask="url(#mask0)" className={styles.cracksContainer}>
				<path
					d="M1.49988 1.1875C2.62488 3.83333 6.21238 9.4625 11.5624 10.8125C16.9124 12.1625 18.7499 12.5417 18.9999 12.5625L23.6874 18.25M23.6874 18.25C26.729 15.0833 32.9499 8.7125 33.4999 8.5625C34.1874 8.375 39.6874 3.625 40.2499 2.6875C40.6999 1.9375 41.854 0.416667 42.3749 -0.25M23.6874 18.25C20.1249 21.5625 12.0124 28.425 8.06238 29.375L0.249878 45.9375"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path
					d="M35.1874 7.96875L36.2499 13L35.6874 19.1875"
					stroke="#863E5A"
				/>
				<path
					d="M35.7186 18.8438L36.9999 24L35.1249 27.125L28.6249 26.6875L21.1561 21.0938"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path
					d="M36.4374 25.5625L41.0624 27.875"
					stroke="#863E5A"
					strokeWidth="1.5"
				/>
				<path
					d="M40.8124 27.875L46.3749 29.75L50.3124 31.25"
					stroke="#863E5A"
					strokeWidth="1.5"
				/>
				<path
					d="M50.3124 31.25L46.3124 38.9375V50.125"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path d="M50.1249 31L60.8124 34.375" stroke="#863E5A" />
				<path
					d="M60.6249 34.25L74.6874 34.5625"
					stroke="#863E5A"
					strokeWidth="1.5"
				/>
			</g>
		</svg>
	) : (
		<svg
			width="140"
			height="50"
			viewBox="0 0 140 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0"
				mask-type="alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="140"
				height="50"
			>
				<rect
					x="0.749878"
					y="0.25"
					width="140"
					height="50"
					rx="3"
					fill="#C4C4C4"
				/>
			</mask>
			<g mask="url(#mask0)" className={styles.cracksContainer}>
				<path
					d="M1.62488 1.1875C2.74988 3.83333 6.33738 9.4625 11.6874 10.8125C17.0374 12.1625 18.8749 12.5417 19.1249 12.5625L23.8124 18.25M23.8124 18.25C26.854 15.0833 33.0749 8.7125 33.6249 8.5625C34.3124 8.375 39.8124 3.625 40.3749 2.6875C40.8249 1.9375 41.979 0.416667 42.4999 -0.25M23.8124 18.25C20.2499 21.5625 12.1374 28.425 8.18738 29.375L0.374878 45.9375"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path
					d="M35.3124 7.96875L36.3749 13L35.8124 19.1875"
					stroke="#863E5A"
				/>
				<path
					d="M35.8436 18.8438L37.1249 24L35.2499 27.125L28.7499 26.6875L21.2811 21.0938"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path
					d="M36.5624 25.5625L41.1874 27.875"
					stroke="#863E5A"
					strokeWidth="1.5"
				/>
				<path
					d="M40.9374 27.875L46.4999 29.75L50.4374 31.25"
					stroke="#863E5A"
					strokeWidth="1.5"
				/>
				<path
					d="M50.4374 31.25L46.4374 38.9375V50.125"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path d="M50.2499 31L60.9374 34.375" stroke="#863E5A" />
				<path
					d="M60.7499 34.25L74.8124 34.5625"
					stroke="#863E5A"
					strokeWidth="1.5"
				/>
				<path
					d="M74.6249 34.5L77.9999 41.5H81.5624L82.2499 42.6875L93.7499 43.5L97.3749 50.0625"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path
					d="M74.3749 34.75L76.8749 29.5V23.25C77.1874 22 78.0874 19.15 79.1874 17.75C80.2874 16.35 88.6457 16.125 92.6874 16.1875L98.8124 20.125L104.687 33.375L93.8749 43.4375"
					stroke="#863E5A"
					strokeWidth="2"
				/>
				<path
					d="M96.6249 18.875L97.2499 16.25C97.6249 16.1667 98.5249 15.9125 99.1249 15.5625C99.7249 15.2125 99.9999 14.25 100.062 13.8125L99.7499 11.8125L101.062 10.6875L102.375 10"
					stroke="#863E5A"
				/>
				<path
					d="M117.75 3.62498L118.375 5.99998L117.75 8.93748C116.062 9.54165 112.4 10.8125 111.25 11.0625C109.812 11.375 104.75 10.75 104.437 10.75C104.187 10.75 102.75 9.99998 102.062 9.62498L101.215 5.58138L106.778 4.70638"
					stroke="#863E5A"
				/>
				<path d="M103.466 5.36339L100.719 0.0312537" stroke="#863E5A" />
				<path
					d="M116.375 9.5L125.25 13.625C127.458 16.125 136.15 21.0125 140.75 20.8125"
					stroke="#863E5A"
				/>
				<path
					d="M118.375 4.14114L126.228 7.64114C127.114 8.09948 134.115 8.93125 140.687 9.03125"
					stroke="#863E5A"
				/>
				<path
					d="M77.9999 19.5L71.4999 8.5C70.1249 8.41666 66.6249 7.425 63.6249 4.125C60.6249 0.824996 60.9582 0.33333 61.4999 0.499996"
					stroke="#863E5A"
					strokeWidth="1.5"
				/>
			</g>
		</svg>
	);

export const LightCrack: React.FC<CrackedBrickProps> = ({ isSmall }) =>
	isSmall ? (
		<svg
			width="66"
			height="51"
			viewBox="0 0 66 51"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0"
				mask-type="alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="66"
				height="51"
			>
				<rect
					x="0.75"
					y="0.25"
					width="65"
					height="50"
					rx="3"
					fill="#C4C4C4"
				/>
			</mask>
			<g mask="url(#mask0)" className={styles.cracksContainer}>
				<path
					d="M1.625 0.9375C2.75 3.58333 6.3375 9.2125 11.6875 10.5625C17.0375 11.9125 18.875 12.2917 19.125 12.3125L23.8125 18M23.8125 18C26.8542 14.8333 33.075 8.4625 33.625 8.3125C34.3125 8.125 39.8125 3.375 40.375 2.4375C40.825 1.6875 41.9792 0.166667 42.5 -0.5M23.8125 18C20.25 21.3125 12.1375 28.175 8.1875 29.125L0.375 45.6875"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path
					d="M35.3125 7.71875L36.375 12.75L35.8125 18.9375"
					stroke="#BA3054"
				/>
				<path
					d="M35.8438 18.5938L37.125 23.75L35.25 26.875L28.75 26.4375L21.2812 20.8438"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path
					d="M36.5625 25.3125L41.1875 27.625"
					stroke="#BA3054"
					strokeWidth="1.5"
				/>
				<path
					d="M40.9375 27.625L46.5 29.5L50.4375 31"
					stroke="#BA3054"
					strokeWidth="1.5"
				/>
				<path
					d="M50.4375 31L46.4375 38.6875V49.875"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path d="M50.25 30.75L60.9375 34.125" stroke="#BA3054" />
				<path
					d="M60.75 34L74.8125 34.3125"
					stroke="#BA3054"
					strokeWidth="1.5"
				/>
			</g>
		</svg>
	) : (
		<svg
			width="140"
			height="50"
			viewBox="0 0 140 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0"
				mask-type="alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="140"
				height="50"
			>
				<rect
					x="0.75"
					y="0.25"
					width="140"
					height="50"
					rx="3"
					fill="#C4C4C4"
				/>
			</mask>
			<g mask="url(#mask0)" className={styles.cracksContainer}>
				<path
					d="M1.625 1.1875C2.75 3.83333 6.3375 9.4625 11.6875 10.8125C17.0375 12.1625 18.875 12.5417 19.125 12.5625L23.8125 18.25M23.8125 18.25C26.8542 15.0833 33.075 8.7125 33.625 8.5625C34.3125 8.375 39.8125 3.625 40.375 2.6875C40.825 1.9375 41.9792 0.416667 42.5 -0.25M23.8125 18.25C20.25 21.5625 12.1375 28.425 8.1875 29.375L0.375 45.9375"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path
					d="M35.3125 7.96875L36.375 13L35.8125 19.1875"
					stroke="#BA3054"
				/>
				<path
					d="M35.8438 18.8438L37.125 24L35.25 27.125L28.75 26.6875L21.2812 21.0938"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path
					d="M36.5625 25.5625L41.1875 27.875"
					stroke="#BA3054"
					strokeWidth="1.5"
				/>
				<path
					d="M40.9375 27.875L46.5 29.75L50.4375 31.25"
					stroke="#BA3054"
					strokeWidth="1.5"
				/>
				<path
					d="M50.4375 31.25L46.4375 38.9375V50.125"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path d="M50.25 31L60.9375 34.375" stroke="#BA3054" />
				<path
					d="M60.75 34.25L74.8125 34.5625"
					stroke="#BA3054"
					strokeWidth="1.5"
				/>
				<path
					d="M74.625 34.5L78 41.5H81.5625L82.25 42.6875L93.75 43.5L97.375 50.0625"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path
					d="M74.375 34.75L76.875 29.5V23.25C77.1875 22 78.0875 19.15 79.1875 17.75C80.2875 16.35 88.6458 16.125 92.6875 16.1875L98.8125 20.125L104.688 33.375L93.875 43.4375"
					stroke="#BA3054"
					strokeWidth="2"
				/>
				<path
					d="M96.625 18.875L97.25 16.25C97.625 16.1667 98.525 15.9125 99.125 15.5625C99.725 15.2125 100 14.25 100.062 13.8125L99.75 11.8125L101.062 10.6875L102.375 10"
					stroke="#BA3054"
				/>
				<path
					d="M117.75 3.62498L118.375 5.99998L117.75 8.93748C116.063 9.54165 112.4 10.8125 111.25 11.0625C109.813 11.375 104.75 10.75 104.438 10.75C104.188 10.75 102.75 9.99998 102.063 9.62498L101.215 5.58138L106.778 4.70638"
					stroke="#BA3054"
				/>
				<path d="M103.466 5.36339L100.719 0.0312537" stroke="#BA3054" />
				<path
					d="M116.375 9.5L125.25 13.625C127.458 16.125 136.15 21.0125 140.75 20.8125"
					stroke="#BA3054"
				/>
				<path
					d="M118.375 4.14114L126.228 7.64114C127.114 8.09948 134.115 8.93125 140.688 9.03125"
					stroke="#BA3054"
				/>
				<path
					d="M78 19.5L71.5 8.5C70.125 8.41666 66.625 7.425 63.625 4.125C60.625 0.824996 60.9583 0.33333 61.5 0.499996"
					stroke="#BA3054"
					strokeWidth="1.5"
				/>
			</g>
		</svg>
	);
